import Image from 'next/image';
import { cn } from '@/lib/utils';

import mastercard from '@/public/global/payments/mastercard.svg';
import maestro from '@/public/global/payments/maestro.png';
import visa from '@/public/global/payments/visa.svg';
import sepa from '@/public/global/payments/sepa.svg';
import crypto from '@/public/global/payments/crypto.svg';

const METHODS = [
  { label: 'Mastercard', logo: mastercard },
  { label: 'Maestro', logo: maestro },
  { label: 'Visa', logo: visa },
  { label: 'Sepa', logo: sepa },
  { label: 'Alle Cryptos', logo: crypto },
];

export default function PaymentMethods({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-col gap-[0.75rem] items-center w-full',
        className,
      )}
    >
      <p className="font-medium opacity-50 text-[#001B14] text-[1.5rem] text-center tracking-[-0.03rem] uppercase mb-0">
        Bezahle sicher mit:
      </p>
      <div className="flex gap-[1.5rem] items-center justify-center opacity-50 flex-wrap">
        {METHODS.map(({ label, logo }) => (
          <div
            key={label}
            className="flex flex-col items-center justify-center gap-[0.25rem]"
          >
            <Image
              src={logo}
              alt={label}
              className="object-contain h-[2.5rem] w-auto"
            />
            <p className="font-medium text-[#001B14] text-[1rem] text-center tracking-[-0.02rem] uppercase whitespace-nowrap mb-0">
              {label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
